var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/core-js/modules/es7.reflect.get-own-metadata.js
// module id = ../../../../core-js/modules/es7.reflect.get-own-metadata.js
// module chunks = 0